export class DateUtil {
    /**
     * Converts a date to UTC midnight (00:00:00.000).
     * Useful when we store the date in the database
     * and we only care about the date component without the time component, and we want to avoid timezone conversion issues.
     * @param date - The date to convert
     * @returns A new Date object set to UTC midnight, or null if input is null
     */
    static convertDate(date: Date) {
        if (date == null) {
            return null;
        }

        const tempDate = new Date(date);
        return new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), 0, 0, 0, 0);
    }

    /**
     * Converts a date to local midnight (00:00:00.000)
     * Useful when we want to update the time component to midnight in the local timezone
     * @param date - The date to convert
     * @returns A new Date object set to local midnight, or null if input is null
     */
    static convertDateToLocal(date: Date) {
        if (date == null) {
            return null;
        }

        const tempDate = new Date(date);
        return new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), 0, 0, 0, 0);
    }

    /**
     * Converts a date to UTC midnight (00:00:00.000) using Date.UTC, which creates a date in UTC timezone.
     * This is an alternative approach to convert a date to UTC midnight, and it can be useful when we want to ensure that the resulting date is in UTC timezone regardless of the local timezone of the input date.
     * @param date - The date to convert
     * @returns A new Date object set to UTC midnight, or null if input is null
     */
    static toUtcDateOnly(date: Date) {
        if (date == null) {
            return null;
        }

        return new Date(Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            0, 0, 0, 0
        ));
    }
}
